import { render, staticRenderFns } from "./FloatSidebar.vue?vue&type=template&id=5be92964&scoped=true"
import script from "./FloatSidebar.vue?vue&type=script&lang=js"
export * from "./FloatSidebar.vue?vue&type=script&lang=js"
import style0 from "./FloatSidebar.vue?vue&type=style&index=0&id=5be92964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be92964",
  null
  
)

export default component.exports